export const locale = navigator.language || 'en-IE';